import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import imageFeedService from "./imageFeedService";

export const getImageFeeds = createAsyncThunk(
  "imageFeed/all",
  async (_, thunkAPI) => {
    try {
      return await imageFeedService.getImageFeeds();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const createImageFeed = createAsyncThunk(
  "imageFeed/add",
  async (feedData, thunkAPI) => {
    try {
      return await imageFeedService.createImageFeed(feedData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const updateAImageFeed = createAsyncThunk(
  "imageFeed/update",
  async (payload, thunkAPI) => {
    try {
      return await imageFeedService.updateImageFeed(payload);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteAImageFeed = createAsyncThunk(
  "imageFeed/delete",
  async (id, thunkAPI) => {
    try {
      return await imageFeedService.deleteImageFeed(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getAImageFeed = createAsyncThunk(
  "imageFeed/get",
  async (id, thunkAPI) => {
    try {
      return await imageFeedService.getAImageFeed(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const resetState = createAction("ImageFeedRevertAll");

const initialState = {
  imageFeeds: [],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};

export const imageFeedSlice = createSlice({
  name: "imageFeeds",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getImageFeeds.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getImageFeeds.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.imageFeeds = action.payload.data;
      })
      .addCase(getImageFeeds.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(createImageFeed.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createImageFeed.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.createdImageFeed = action.payload;
      })
      .addCase(createImageFeed.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(updateAImageFeed.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateAImageFeed.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.updatedImageFeed = action.payload;
      })
      .addCase(updateAImageFeed.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(deleteAImageFeed.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteAImageFeed.fulfilled, (state) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
      })
      .addCase(deleteAImageFeed.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getAImageFeed.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAImageFeed.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.feedImage = action.payload.data.feed_image;
        state.feedLink = action.payload.data.link;
        state.feedStatus = action.payload.data.status;
        state.feedOrder = action.payload.data.order;
      })
      .addCase(getAImageFeed.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(resetState, () => initialState);
  },
});

export default imageFeedSlice.reducer;
